import {Button, Text, useDisclosure} from '@chakra-ui/react';
import {useMutation} from '@tanstack/react-query';
import {cancelOrder} from 'api/requests';
import {colors, useCustomerContext} from 'components/providers';
import {useActiveOrders, useToast} from 'hooks';
import {useRouter} from 'next/router';
import {FC} from 'react';
import GTMService from 'services/ga4';
import {TranslationKeys} from 'translations';
import {ICanceledOrderRequest, IOrder} from 'types';

import {AlertCanceledOrder} from './components';

interface IProps {
  isCanceled: boolean;
  t: (term: TranslationKeys) => string;
  uuid: string;
  is_can_be_canceled: boolean;
  order: IOrder;
}

export const CancelOrder: FC<IProps> = ({is_can_be_canceled, isCanceled, t, uuid, order}) => {
  const toast = useToast();
  const router = useRouter();
  const {isOpen, onOpen, onClose} = useDisclosure();
  const {refetch} = useActiveOrders();
  const {refetchCustomer} = useCustomerContext();

  const cancelation = useMutation<any, any, ICanceledOrderRequest, any>( //this example is true typing useMutation
    async ({uuid, reason}) => {
      return await cancelOrder({uuid, reason});
    },
    {
      onSuccess: () => {
        GTMService.refund(order);
        refetch();
        refetchCustomer();
        toast.success('Order canceled success');
        router.push(`/`);
      },
      onError: (error) => {
        toast.error(`${error?.response?.data}`);
        refetch();
      },
    },
  );

  const onConfirm = (reason: string) => {
    cancelation.mutate({uuid, reason});
  };

  return (
    <>
      {isCanceled && (
        <Text fontWeight="500" color={colors.textGray} mb="15px">
          {t('ORDER_CANCELED')}
        </Text>
      )}
      {!isCanceled && is_can_be_canceled && (
        <Button onClick={onOpen} bg="red" color="white" isDisabled={cancelation.isPending}>
          {t('ORDER_CANCEL')}
        </Button>
      )}
      {isOpen && <AlertCanceledOrder isOpen={isOpen} onClose={onClose} onConfirm={onConfirm} />}
    </>
  );
};
